import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { IMAGES_ICON } from "../../assets/images/exportImages";
import CloseIcon from '@mui/icons-material/Close';


export default function CustomDialogue({ displaySize = 'sm', title, dialogueFlag, mainContent, actionContent, onCloseClick, fullScreen = false, borderRadius = "25px" }: any) {

    return <Dialog fullScreen={fullScreen} fullWidth maxWidth={displaySize} open={dialogueFlag} onClose={onCloseClick} disableEscapeKeyDown={true}
        PaperProps={{ sx: { borderRadius: borderRadius }, }}>
        <DialogTitle className={`px-0 ${title ? '' : 'pb-0'} border-bottom`}>
            <div className="d-flex justify-content-between align-items-center px-4">
                <span className="fw-bold">{title}</span>
                <CloseIcon  onClick={onCloseClick} />
            </div>
        </DialogTitle>
        <DialogContent className="px-4">{mainContent}</DialogContent>
        <DialogActions className="border-top">{actionContent}</DialogActions>
    </Dialog>
}
